import React,{useEffect} from "react";
import "./Work.css";
import WorkCard from "../components/WorkCard";
import { workData } from "./WorkList";
import anime from "animejs/lib/anime.es.js";
function Work() {
  
  useEffect(()=>{
    anime({
      targets: "#workSvg path",
      strokeDashoffset: [anime.setDashoffset, 0],
      easing: "easeInOutSine",
      duration:2500,
      delay: function (el, i) {
        return i * 200;
      },
      direction: "alternate",
      loop: true,
    });
  },[])
  return (
    <>
      <div className="workMain" id="works">
        <h1 className="workHead">WORKS</h1>
        <div>
          
          <svg
          id="workSvg"
            width="460.44"
            height="87.242"
            viewBox="0 0 460.44 87.242"
            xmlns="http://www.w3.org/2000/svg"
          >
            <g
              id="svgGroup"
              stroke-linecap="round"
              fill-rule="evenodd"
              font-size="9pt"
              stroke="#000000"
              stroke-width="0.3mm"
              fill="none"
              // style="stroke:#000000;stroke-width:0.2mm;fill:none"
            >
              <path
                d="M 96.12 1.441 L 124.8 1.441 L 90.36 86.401 L 57.24 86.401 L 55.92 38.161 L 37.56 86.401 L 4.44 86.401 L 0 1.441 L 28.68 1.441 L 27 54.961 L 47.88 1.441 L 76.92 1.441 L 78.96 54.961 L 96.12 1.441 Z"
                id="0"
                vector-effect="non-scaling-stroke"
              />
              <path
                d="M 151.048 86.165 A 44.491 44.491 0 0 0 161.04 87.241 Q 175.92 87.241 187.38 80.641 Q 198.84 74.041 205.14 62.161 A 52.095 52.095 0 0 0 209.556 50.729 A 62.101 62.101 0 0 0 211.44 35.161 A 44.666 44.666 0 0 0 211.089 29.483 A 35.118 35.118 0 0 0 207 16.741 Q 202.56 8.761 194.34 4.381 A 35.95 35.95 0 0 0 184.81 0.963 A 47.019 47.019 0 0 0 175.08 0.001 Q 160.32 0.001 148.98 6.541 Q 137.64 13.081 131.34 24.781 Q 125.04 36.481 125.04 51.721 A 45.261 45.261 0 0 0 125.326 56.871 A 36.109 36.109 0 0 0 129.48 70.261 Q 133.92 78.361 142.08 82.801 A 35.147 35.147 0 0 0 151.048 86.165 Z M 165.12 62.401 A 19.851 19.851 0 0 0 171.209 61.497 A 17.176 17.176 0 0 0 175.98 59.101 Q 180.6 55.801 183 50.341 A 28.831 28.831 0 0 0 185.39 39.337 A 33.258 33.258 0 0 0 185.4 38.521 Q 185.4 31.921 181.86 28.261 A 11.439 11.439 0 0 0 176.577 25.205 Q 174.401 24.601 171.72 24.601 Q 165.48 24.601 160.8 27.841 A 20.648 20.648 0 0 0 153.679 36.498 A 24.403 24.403 0 0 0 153.66 36.541 A 28.29 28.29 0 0 0 151.205 47.766 A 32.565 32.565 0 0 0 151.2 48.361 Q 151.2 53.81 153.613 57.296 A 11.505 11.505 0 0 0 154.74 58.681 A 11.283 11.283 0 0 0 159.767 61.689 Q 161.537 62.223 163.663 62.356 A 23.249 23.249 0 0 0 165.12 62.401 Z"
                id="1"
                vector-effect="non-scaling-stroke"
              />
              <path
                d="M 273.24 53.881 L 285.96 86.401 L 256.68 86.401 L 246 55.921 L 240.6 86.401 L 213.96 86.401 L 228.96 1.441 L 268.56 1.441 Q 277.622 1.441 283.787 4.126 A 21.546 21.546 0 0 1 289.32 7.561 A 20.092 20.092 0 0 1 296.338 22.004 A 27.819 27.819 0 0 1 296.4 23.881 A 32.233 32.233 0 0 1 296.28 26.73 A 23.724 23.724 0 0 1 295.92 29.281 Q 294.36 37.921 288.48 44.461 A 31.878 31.878 0 0 1 276.899 52.56 A 39.676 39.676 0 0 1 273.24 53.881 Z M 251.64 23.761 L 249.12 38.161 L 259.68 38.161 Q 262.564 38.161 264.535 37.179 A 7.027 7.027 0 0 0 265.74 36.421 A 7.091 7.091 0 0 0 267.67 34.024 Q 268.173 33.04 268.49 31.809 A 14.38 14.38 0 0 0 268.68 30.961 A 5.198 5.198 0 0 0 268.748 30.506 Q 268.8 30.031 268.8 29.401 A 6.684 6.684 0 0 0 268.583 27.65 A 4.82 4.82 0 0 0 267.12 25.261 Q 265.775 24.06 263.429 23.82 A 12.121 12.121 0 0 0 262.2 23.761 L 251.64 23.761 Z"
                id="2"
                vector-effect="non-scaling-stroke"
              />
              <path
                d="M 390.48 1.441 L 353.88 42.121 L 377.4 86.401 L 345.72 86.401 L 327.48 49.441 L 321 86.401 L 294.36 86.401 L 309.36 1.441 L 336 1.441 L 329.64 37.201 L 360.36 1.441 L 390.48 1.441 Z"
                id="3"
                vector-effect="non-scaling-stroke"
              />
              <path
                d="M 387.48 59.161 L 415.8 59.161 A 15.137 15.137 0 0 0 415.74 60.032 Q 415.653 62.271 416.333 63.719 A 4.443 4.443 0 0 0 416.94 64.681 Q 418.44 66.481 421.92 66.481 A 7.144 7.144 0 0 0 423.556 66.302 A 5.222 5.222 0 0 0 425.52 65.401 A 3.512 3.512 0 0 0 426.925 62.895 A 5.194 5.194 0 0 0 426.96 62.281 A 5.269 5.269 0 0 0 425.247 58.375 A 8.267 8.267 0 0 0 424.14 57.481 A 25.488 25.488 0 0 0 422.283 56.344 Q 420.202 55.176 417.085 53.79 A 120.294 120.294 0 0 0 415.08 52.921 Q 408.24 50.041 403.86 47.401 A 24.799 24.799 0 0 1 397.495 41.843 A 29.344 29.344 0 0 1 396.24 40.201 A 17.07 17.07 0 0 1 393.475 33.703 A 24.074 24.074 0 0 1 393 28.801 A 30.175 30.175 0 0 1 394.056 20.659 A 24.642 24.642 0 0 1 397.5 13.261 A 27.075 27.075 0 0 1 407.614 4.488 A 33.509 33.509 0 0 1 410.04 3.361 A 42.792 42.792 0 0 1 420.685 0.513 A 55.949 55.949 0 0 1 428.4 0.001 Q 437.64 0.001 444.9 2.881 Q 452.16 5.761 456.3 11.221 A 20.371 20.371 0 0 1 460.39 22.517 A 25.632 25.632 0 0 1 460.44 24.121 A 12.772 12.772 0 0 1 460.425 24.688 Q 460.385 25.574 460.237 27.11 A 113.255 113.255 0 0 1 460.2 27.481 L 431.52 27.481 A 42.838 42.838 0 0 0 431.614 26.897 Q 431.76 25.936 431.76 25.561 Q 431.76 23.444 430.623 22.207 A 3.986 3.986 0 0 0 430.44 22.021 A 4.399 4.399 0 0 0 428.385 20.931 Q 427.699 20.766 426.892 20.761 A 8.187 8.187 0 0 0 426.84 20.761 A 5.681 5.681 0 0 0 425.26 20.97 A 4.439 4.439 0 0 0 423.48 21.961 A 3.969 3.969 0 0 0 422.166 24.829 A 5.384 5.384 0 0 0 422.16 25.081 A 4.902 4.902 0 0 0 423.347 28.259 Q 423.892 28.924 424.688 29.529 A 10.385 10.385 0 0 0 424.92 29.701 A 28.813 28.813 0 0 0 426.729 30.886 Q 428.749 32.115 431.75 33.616 A 131.858 131.858 0 0 0 433.68 34.561 A 142.352 142.352 0 0 1 438.481 36.94 Q 442.207 38.881 445.02 40.681 A 26.629 26.629 0 0 1 452.089 47.357 A 30.882 30.882 0 0 1 452.76 48.301 A 18.257 18.257 0 0 1 455.617 55.426 A 24.854 24.854 0 0 1 456 59.881 Q 456 67.681 451.86 73.921 A 25.937 25.937 0 0 1 444.018 81.496 A 33.321 33.321 0 0 1 439.92 83.701 A 38.06 38.06 0 0 1 430.82 86.463 Q 426.446 87.241 421.44 87.241 A 63.399 63.399 0 0 1 411.459 86.503 Q 402.643 85.096 396.54 81.001 A 25.055 25.055 0 0 1 396.395 80.903 Q 387.24 74.667 387.24 62.761 Q 387.24 61.842 387.381 60.22 A 81.074 81.074 0 0 1 387.48 59.161 Z"
                id="4"
                vector-effect="non-scaling-stroke"
              />
            </g>
          </svg>
        </div>
        {workData?.map((elem) => {
          return (
            <>
              <WorkCard
                title={elem.title}
                content={elem.content}
                image={elem.image}
                link={elem.link}
              />
            </>
          );
        })}
      </div>
    </>
  );
}

export default Work;
